// extracted by mini-css-extract-plugin
export default {"form":"NewEntry_form__7ohck","loader":"NewEntry_loader__xzW1x"};